interface ImageQuotaEligibility {
  open: boolean;
  generationEnabled: boolean;
}

/** Quota is flow-owned: closed or gate-disabled image pickers must stay network-idle. */
export function shouldFetchImageQuota({ open, generationEnabled }: ImageQuotaEligibility): boolean {
  return open && generationEnabled;
}
